import React from 'react';
import { Mic, Minus, Plus } from 'lucide-react';

export function ExtraMicrophoneSection({ extraMicrophones, onChange, formatIDR }) {
  const maxExtra = 2;
  
  const handleDecrease = () => {
    if (extraMicrophones > 0) {
      onChange(extraMicrophones - 1);
    }
  };
  
  const handleIncrease = () => {
    if (extraMicrophones < maxExtra) {
      onChange(extraMicrophones + 1);
    }
  };

  return (
    <div 
      className="p-6 border border-border hover:border-primary/50 transition-colors"
      data-testid="extra-microphone-section"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className={`p-2 rounded-lg ${extraMicrophones > 0 ? 'bg-primary/20' : 'bg-muted'}`}>
            <Mic className={`w-6 h-6 ${extraMicrophones > 0 ? 'text-primary' : 'text-foreground-muted'}`} />
          </div>
          <div>
            <h3 className="text-lg font-heading font-semibold">Extra Microphones</h3>
            <p className="text-sm text-foreground-muted">2 podcast microphones included in your session</p>
          </div>
        </div>
        
        <div className="flex items-center gap-4">
          <span className="text-primary font-semibold">
            {formatIDR(100000)}/mic
          </span>
          
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={handleDecrease}
              disabled={extraMicrophones === 0}
              className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
                extraMicrophones === 0 
                  ? 'bg-muted text-foreground-muted cursor-not-allowed' 
                  : 'bg-primary/20 text-primary hover:bg-primary/30'
              }`}
              data-testid="extra-mic-decrease"
            >
              <Minus className="w-4 h-4" />
            </button>
            
            <span className="w-8 text-center font-semibold text-lg" data-testid="extra-mic-count">
              {extraMicrophones}
            </span>
            
            <button
              type="button"
              onClick={handleIncrease}
              disabled={extraMicrophones >= maxExtra}
              className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
                extraMicrophones >= maxExtra 
                  ? 'bg-muted text-foreground-muted cursor-not-allowed' 
                  : 'bg-primary/20 text-primary hover:bg-primary/30'
              }`}
              data-testid="extra-mic-increase"
            >
              <Plus className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
      
      {extraMicrophones > 0 && (
        <div className="mt-4 pt-4 border-t border-border flex items-center justify-between">
          <p className="text-sm text-foreground-muted">
            <span className="text-primary font-semibold">{2 + extraMicrophones} microphones</span> will be available for your session
          </p>
          <p className="text-sm font-semibold text-primary">
            +{formatIDR(extraMicrophones * 100000)}
          </p>
        </div>
      )}
    </div>
  );
}
